export default __webpack_public_path__ + "assets/images/901c82311a413fdbe0bb7403cabae1a7.png";